// Lax.js
import lax from 'lax.js';

window.addEventListener('load', () => {
  lax.init();

  // Add a driver that we use to control our animations
  lax.addDriver('scrollY', function () {
    return window.scrollY;
  });

  // Add animation bindings to elements
  lax.addElements('.scroll-ccc', {
    scrollY: {
      translateX: [
        ['elInY', 'elOutY'],
        ['elWidth', 'elWidth * -1'],
      ],
    },
  });

  lax.addElements('.lax-shrink', {
    scrollY: {
      scale: [
        ['elInY', 'elCenterY'],
        [2, 1],
      ],
      opacity: [
        ['elInY', 'elCenterY'],
        [0, 1],
      ],
    },
  });
});
